import { Component, isDevMode } from '@angular/core';
import { Router, NavigationEnd, Scroll } from '@angular/router';
import { User } from './_models';
import { AuthenticationService, UtilsService } from './_services';
import { TranslateService } from '@ngx-translate/core';
import { Title }     from '@angular/platform-browser';
import { Location, ViewportScroller } from '@angular/common';
import { environment } from 'src/environments/environment';
import { filter } from 'rxjs/operators';

declare const $: any;
declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {

  public currentUser: User;

  
  constructor(
    private titles: Title,
    private router: Router,
    private utils : UtilsService,
    private auth: AuthenticationService,
    private translate: TranslateService,
    private location : Location,
    private viewportScroller : ViewportScroller
    
  ) {
    this.auth.currentUser.subscribe(x => this.currentUser = x);
    
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('ca');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('ca');

    // if url changes , close all posibly open modals
    this.location.subscribe(location => {
      $('body').removeClass('modal-open');
      $('.modal-backdrop').remove();
    });

    this.router.events.subscribe(event => {
      
      if (event instanceof NavigationEnd) {
        setTimeout(() => {
          if (typeof gtag === 'function') {
            gtag('config', 'UA-154574277-1', {
              page_path: event.urlAfterRedirects,
              page_title: document.title
            });
          }
        },  environment.READY_TIMEOUT);
      }
    });    
    
    this.router.events.pipe(filter(e => e instanceof Scroll)).subscribe((e: any) => {
    // this is fix for dynamic generated(loaded..?) content
      setTimeout(() => {
        if (e.position) {
            this.viewportScroller.scrollToPosition(e.position);
        } else if (e.anchor) {
            this.viewportScroller.scrollToAnchor(e.anchor);
        } else {
            this.viewportScroller.scrollToPosition([0, 0]);
        }
      });
    });
  }

  ngOnInit() {
	  if(isDevMode()){
		  require("style-loader!./../styles2.css");
	  } 
/*
      this.router.events.subscribe((evt) => {
          if (!(evt instanceof NavigationEnd )) {
              return;
          }
          $("html, body").stop().animate({scrollTop:0}, 500, 'swing');
      });
*/
  }

  ngAfterViewChecked () {
    
      /////////////////////// tooltip
      // Start tooltip jqcode
      $('[data-toggle="tooltip"]').tooltip().on('click', function () {
          $(this).tooltip('hide');
      });
      // End tooltip jqcode

    }

    onClose() {
      return this.auth.logout().subscribe();
    }
}

